module.exports = __webpack_public_path__ + "img/snowman.33e88803.svg";